// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlurButton__button-ca8b9e {
  width: 40px;
  height: 40px;
  border-radius: 100px !important;
  min-width: 40px;
  display: flex;
  align-items: center;
  padding: 0;
  position: absolute;
  top: 16px;
  inset-inline-end: 16px;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/components/RoomCallPreviewVideo/BlurButton/BlurButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;AACF","sourcesContent":[".button {\n  width: 40px;\n  height: 40px;\n  border-radius: 100px !important;\n  min-width: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  position: absolute;\n  top: 16px;\n  inset-inline-end: 16px;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `BlurButton__button-ca8b9e`
};
module.exports = ___CSS_LOADER_EXPORT___;
